import create from 'zustand';
import { ReplaceMeterStep } from './enums/replaceMeterSteps';

export const REPLACE_METER_STEPS_COUNT = Object.keys(ReplaceMeterStep).length / 2;

const INITIAL_STATE = {
  currentStep: ReplaceMeterStep.OldValues,
} as const;

const getNextStep = (currentStep: ReplaceMeterStep) => {
  switch (currentStep) {
    case ReplaceMeterStep.OldValues:
      return ReplaceMeterStep.NewValues;

    case ReplaceMeterStep.NewValues:
      return ReplaceMeterStep.Details;

    case ReplaceMeterStep.Details:
    default:
      return ReplaceMeterStep.Review;
  }
};

const getPreviousStep = (currentStep: ReplaceMeterStep) => {
  switch (currentStep) {
    case ReplaceMeterStep.Review:
      return ReplaceMeterStep.Details;

    case ReplaceMeterStep.Details:
      return ReplaceMeterStep.NewValues;

    case ReplaceMeterStep.NewValues:
    default:
      return ReplaceMeterStep.OldValues;
  }
};

export interface ReplaceMeterStepsStore {
  currentStep: ReplaceMeterStep;
  setCurrentStep: (payload: ReplaceMeterStep) => void;
  /**
   * Sets next replace step based on current step and state of replacement, defaults to last step (Review)
   */
  setNextStep: () => void;
  /**
   * Sets previous replace step based on current step and state of replacement, defaults to first step (OldMeterValues)
   */
  setPreviousStep: () => void;
  // setPreviousStep(): void;
  reset: () => void;
}

export const useReplaceMeterStepsStore = create<ReplaceMeterStepsStore>((set, get) => ({
  ...INITIAL_STATE,
  setCurrentStep: (step: ReplaceMeterStep) => {
    set(() => ({ currentStep: step }));
  },
  setNextStep() {
    const { currentStep } = get();
    const nextStep = getNextStep(currentStep);
    set(() => ({ currentStep: nextStep }));
  },
  setPreviousStep() {
    const { currentStep } = get();
    const previousStep = getPreviousStep(currentStep);
    set(() => ({ currentStep: previousStep }));
  },
  reset: () => set(INITIAL_STATE),
}));
